var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPercentage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 0.600098L17.5 2.6001L2.5 17.6001L0.5 15.6001L15.5 0.600098ZM4 1.1001C5.66 1.1001 7 2.4401 7 4.1001C7 5.7601 5.66 7.1001 4 7.1001C2.34 7.1001 1 5.7601 1 4.1001C1 2.4401 2.34 1.1001 4 1.1001ZM14 11.1001C15.66 11.1001 17 12.4401 17 14.1001C17 15.7601 15.66 17.1001 14 17.1001C12.34 17.1001 11 15.7601 11 14.1001C11 12.4401 12.34 11.1001 14 11.1001ZM4 3.1001C3.45 3.1001 3 3.5501 3 4.1001C3 4.6501 3.45 5.1001 4 5.1001C4.55 5.1001 5 4.6501 5 4.1001C5 3.5501 4.55 3.1001 4 3.1001ZM14 13.1001C13.45 13.1001 13 13.5501 13 14.1001C13 14.6501 13.45 15.1001 14 15.1001C14.55 15.1001 15 14.6501 15 14.1001C15 13.5501 14.55 13.1001 14 13.1001Z",
    fill: "#2E2F32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercentage);
export default __webpack_public_path__ + "static/media/Percentage.f2fe668ae88ca82a4994069fbfe3c327.svg";
export { ForwardRef as ReactComponent };